import React, { useEffect, useMemo, useState } from "react"
import { BLACK, PRIMARY } from "../../appConstants"
import { Outlet, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";


const ReportManagementPage: React.FC = () => {
    const navigate = useNavigate();
    const [selectedTab, setSelectedTab] = useState<string>("VENDOR");
    const { brand_id: brandId, platform_id: platformId } = useSelector((state: any) => state.appData);

    useEffect(() => {
        navigate(`/reportsUpload/vendor/${brandId}/${platformId}`);
        setSelectedTab("VENDOR");
    }, [brandId]);

    const tabs = useMemo(() => {
        return [
            { id: "VENDOR", name: "Vendor", url: "/reportsUpload/vendor" }
        ]
    }, []);

    const onTabChange = (tab: string, url: string) => {
        setSelectedTab(tab);
        navigate(url + "/" + brandId);
    }

    return (
        <div style={{ height: "calc(100vh - 72px)" }} >
            <div className="flex flex-row px-10" style={{ height: 52, boxShadow: "0px 4px 10px 4px rgba(99, 99, 99, 0.05)" }} >
                {
                    tabs.map(tab => {
                        return(
                            <div
                            onClick={() => onTabChange(tab.id, tab.url)}
                            key={tab.id} className="p-4 cursor-pointer"
                            style={{
                                fontSize: 14, fontWeight: 500, color: selectedTab === tab.id ? PRIMARY.P_BLue : BLACK.B_40,
                                borderBottom: selectedTab === tab.id ? `2px solid ${PRIMARY.P_BLue}` : ""
                            }} >
                                {tab.name}
                            </div>
                        )
                    })
                }
            </div>
            <div className="" style={{ height: "calc(100vh - 124px)" }} >
                <Outlet />
            </div>
        </div>
    )
}


export default ReportManagementPage